
// M014 product benifits
function initProductBenifits() {
    if ($(".productBenefits").length > 0) {
        $(".productBenefits").each(function () {
            var $pb = $(this)
            $(this).find(".productBenefitsSwitch").click(function () {
                $pb.find(".productBenefitsList").toggle();
                $pb.find(".productBenefitsBody").toggle();
                $pb.find(".productBenefitsSwitch").toggleClass("opened");

                updateProductBenifits();
            });
            $(this).find(".productBenefitsSwitch").on("keydown", handleKeyDownForClick);
        });
    }
}

function updateProductBenifits() {
    if ($(".productBenefits").length > 0) {
        $(".productBenefits").each(function () {
            var $pbBody = $(this).find(".productBenefitsBody")
            var $pbBodyCol1 = $pbBody.find(".productBenefitsBodyCol").first();
            var $pbBodyCol2 = $pbBody.find(".productBenefitsBodyCol").last();

            var elementCount1 = $pbBodyCol1.find(".productBenefitsBodyColElement").length;
            var elementCount2 = $pbBodyCol2.find(".productBenefitsBodyColElement").length;

            var x = elementCount1;
            if (elementCount1 > elementCount2) {
                x = elementCount2;
            }

            for (var i = 0; i < x; i++) {
                var $element1 = $pbBodyCol1.find(".productBenefitsBodyColElement").eq(i);
                var $element2 = $pbBodyCol2.find(".productBenefitsBodyColElement").eq(i);

                if ($element1 && $element2 && $element1.height() > 0 && $element2.height() > 0) {

                    $element1.css("height", "auto");
                    $element2.css("height", "auto");

                    if ($element1.height() > $element2.height()) {
                        $element2.css("height", $element1.height());
                    }
                    else if ($element2.height() > $element1.height()) {
                        $element1.css("height", $element2.height());
                    }
                }
            }

            /*
            for (var i = 0; i < lngth; i++) {
              if($pbBody.find(".productBenefitsBodyIconElement").eq(i).height() >
              $pbBody.find(".productBenefitsBodyElement")
            }
            */

        });
    }
}